import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Wrench, CheckCircle, XCircle, Loader } from 'lucide-react';
import API from '../api';

export default function VerifyEmailPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token');

  const [status, setStatus] = useState('loading'); // 'loading' | 'success' | 'error'
  const [errorMsg, setErrorMsg] = useState('');

  useEffect(() => {
    if (!token) {
      setStatus('error');
      setErrorMsg('Lien invalide : aucun token trouvé.');
      return;
    }

    API.get(`/api/auth/verify-email?token=${encodeURIComponent(token)}`)
      .then(() => setStatus('success'))
      .catch((err) => {
        setStatus('error');
        setErrorMsg(err.response?.data?.detail || 'Lien invalide ou déjà utilisé.');
      });
  }, [token]);

  return (
    <div className="min-h-screen flex items-center justify-center p-8" style={{ background: 'var(--bg)' }}>
      <div className="w-full max-w-md">
        {/* Logo */}
        <a href="/" className="flex items-center gap-3 mb-10 hover:opacity-80 transition-opacity justify-center">
          <div className="w-10 h-10 rounded-xl flex items-center justify-center" style={{ background: 'var(--primary-gradient)' }}>
            <Wrench size={20} color="white" />
          </div>
          <span className="text-2xl font-bold" style={{ color: 'var(--text)',  }}>Bedee</span>
        </a>

        <div className="rounded-2xl p-8 text-center space-y-6"
          style={{ background: 'var(--surface)', border: '1px solid var(--border)' }}>

          {status === 'loading' && (
            <>
              <div className="w-16 h-16 rounded-full flex items-center justify-center mx-auto"
                style={{ background: 'var(--primary-50)' }}>
                <Loader size={28} className="animate-spin" style={{ color: 'var(--primary-solid)' }} />
              </div>
              <div>
                <h2 className="text-2xl font-bold mb-1" style={{ color: 'var(--text)',  }}>
                  Vérification en cours…
                </h2>
                <p className="text-sm" style={{ color: 'var(--text-muted)' }}>
                  Veuillez patienter quelques instants.
                </p>
              </div>
            </>
          )}

          {status === 'success' && (
            <>
              <div className="w-16 h-16 rounded-full flex items-center justify-center mx-auto"
                style={{ background: '#F0FDF4' }}>
                <CheckCircle size={32} style={{ color: '#16A34A' }} />
              </div>
              <div>
                <h2 className="text-2xl font-bold mb-2" style={{ color: 'var(--text)',  }}>
                  Email vérifié !
                </h2>
                <p className="text-sm leading-relaxed" style={{ color: 'var(--text-muted)' }}>
                  Votre adresse email a bien été confirmée. Vous pouvez maintenant vous connecter.
                </p>
              </div>
              <button
                onClick={() => navigate('/login')}
                data-testid="goto-login-btn"
                className="w-full py-3 rounded-lg font-semibold text-white text-sm transition-opacity hover:opacity-90"
                style={{ background: 'var(--primary-gradient)' }}
              >
                Se connecter
              </button>
            </>
          )}

          {status === 'error' && (
            <>
              <div className="w-16 h-16 rounded-full flex items-center justify-center mx-auto"
                style={{ background: '#FEF2F2' }}>
                <XCircle size={32} style={{ color: '#DC2626' }} />
              </div>
              <div>
                <h2 className="text-2xl font-bold mb-2" style={{ color: 'var(--text)',  }}>
                  Lien invalide
                </h2>
                <p className="text-sm leading-relaxed" style={{ color: 'var(--text-muted)' }}>
                  {errorMsg}
                </p>
              </div>
              <button
                onClick={() => navigate('/login')}
                data-testid="goto-login-from-error-btn"
                className="w-full py-3 rounded-lg font-semibold text-sm transition-opacity hover:opacity-90"
                style={{ background: 'var(--surface-hover)', color: 'var(--text)', border: '1px solid var(--border)' }}
              >
                Retour à la connexion
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
